import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        filter: '=',
        sites: '='
    },
    template: `
        <ul class="actions01">
            <li class="primary">
                <a class="btn add" ng-click="vm.addForms(vm.list, vm.filter, vm.sites)">{{ 'forms.Add form' | translate }}</a>
            </li>
            <li>
                <a ng-if="!vm.isOpen" class="btn ico-download" ng-click="vm.exportModal()">{{ 'forms.Export data dump' | translate }}</a>
            </li>
        </ul>
    `
})

export default class {
    constructor ($state, ModalService) {
        this.$state = $state;
        this.ModalService = ModalService;
    }

    addForms (list, filter, sites) {
        const { $state } = this;
        return this.ModalService.open({
            template: '<modals-forms-add class="wrapper" sites="vm.sites" uib-modal-instance="vm.$uibModalInstance"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.sites = sites;
            },
            size: 'large'
        }).then(form => {
            $state.go('authorized.forms.forms.form.general', {
                id: form.id
            });
        });
    }

    exportModal () {
        this.isOpen = true;
        this.ModalService.open({
            template: `
                <modals-forms-export
                    ng-if="vm.courses"
                    class="wrapper"
                    uib-modal-instance="vm.uibModalInstance"
                    forms="vm.forms"
                    courses="vm.courses"
                    sites="vm.sites"
                />
            `,
            resolve: {
                forms: (FormResource, FORMS_TYPE_ENUM) => {
                    return FormResource.query({
                        'types[]': [
                            FORMS_TYPE_ENUM.KEYS.CERTIFICATION,
                            FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK
                        ],
                        expand: 'activeI18n',
                        fields: 'id', // expand fields will be included by default
                        pageSize: 0
                    }).$promise;
                },
                sites: (SiteResource) => {
                    return SiteResource.query({
                        formSites: true,
                        fields: 'id,name',
                        pageSize: 0
                    }).$promise;
                }
            },
            size: 'large',
            controller ($uibModalInstance, forms, sites, CourseResource, COURSE_TRAINING_TYPE_ENUM) {
                this.uibModalInstance = $uibModalInstance;
                this.forms = forms;
                this.sites = sites;
                CourseResource.query({
                    trainingType: COURSE_TRAINING_TYPE_ENUM.KEYS.TEST,
                    expand: 'activeI18n,testTrainings,courseTrainingForms',
                    fields: 'id', // expand fields will be included by default
                    pageSize: 0,
                    'courseAccessSiteIds[]': this.sites.map(site => {
                        return site.id;
                    })
                }).$promise.then((courses) => {
                    this.courses = courses;
                });
            }
        }).then(() => {
            this.isOpen = false;
        }).catch(() => {
            this.isOpen = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/actions/index.js